import { render, staticRenderFns } from "./commentBox.vue?vue&type=template&id=0cf40fce&scoped=true&"
import script from "./commentBox.vue?vue&type=script&lang=js&"
export * from "./commentBox.vue?vue&type=script&lang=js&"
import style0 from "./commentBox.vue?vue&type=style&index=0&id=0cf40fce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf40fce",
  null
  
)

export default component.exports